export default "__VITE_ASSET__f44e1c1c__"